import React from 'react';
import {Route, Routes} from "react-router-dom";
import DetailSinistreContainer from "./DetailSinistre/DetailSinistreContainer";
import AjoutReparateurContainer from "./AjoutReparateur/AjoutReparateurContainer";
import RouterParamsWrapper from "../../RouterParamsWrapper.jsx";

const Sinistre = (props) => {
    const AjoutReparateurWithParams = RouterParamsWrapper(AjoutReparateurContainer)

    return (
        <Routes>
            <Route index element={<DetailSinistreContainer/>} />
            <Route exact path={'/ajouter-reparateur'} element={<AjoutReparateurWithParams/>} />
        </Routes>
    );
};

export default Sinistre;